module.exports = {
	"ha": "fha",
	"id": 6.1,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 680,
			"height": 400,
			"marginLeft": 100,
			"marginRight": 180,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 6.1</span>                 <span style=\"display: table-cell;\">PCS Components for Fraser Health, 2017 Q2–2019 Q1 <sup style=\"font-size: 10px;\">10</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 5,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "Percentage",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "<3 CD4 Tests",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					24.675324675324674,
					18.478260869565215,
					17.5,
					14.457831325301203,
					12.162162162162163,
					15.686274509803921,
					13.725490196078432,
					{
						"y": 15.789473684210526,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 10,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\"><3 CD4 Tests</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "<3 Viral Load Tests",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					14.285714285714285,
					9.782608695652174,
					11.25,
					10.843373493975903,
					8.108108108108109,
					11.76470588235294,
					9.803921568627452,
					{
						"y": 7.894736842105263,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\"><3 Viral Load Tests</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "No Baseline Genotype",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					5.194805194805195,
					7.608695652173914,
					5,
					8.433734939759036,
					9.45945945945946,
					13.725490196078432,
					21.568627450980394,
					{
						"y": 21.052631578947366,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">No Baseline Genotype</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Baseline CD4 <200/µL",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					25.97402597402597,
					26.08695652173913,
					27.500000000000004,
					27.710843373493976,
					28.37837837837838,
					27.450980392156865,
					37.254901960784316,
					{
						"y": 34.21052631578947,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Baseline CD4 <200/µL</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Non-Recommended ART",
				"pointPlacement": "on",
				"color": "#560054",
				"dashStyle": "Solid",
				"data": [
					6.493506493506493,
					11.956521739130435,
					10,
					14.457831325301203,
					14.864864864864865,
					15.686274509803921,
					15.686274509803921,
					{
						"y": 15.789473684210526,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 0,
							"style": {
								"color": "#560054",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Non-Recommended ART</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Non Viral Suppression at 9 Mo.",
				"pointPlacement": "on",
				"color": "#9d070d",
				"dashStyle": "Solid",
				"data": [
					25.97402597402597,
					23.91304347826087,
					21.25,
					19.27710843373494,
					20.27027027027027,
					23.52941176470588,
					19.607843137254903,
					{
						"y": 21.052631578947366,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d070d",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Non Viral Suppression at 9 Mo.</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "n=",
				"visible": false,
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"data": [
					77,
					92,
					80,
					83,
					74,
					51,
					51,
					{
						"y": 38,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#231f20",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">n=</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_6_1.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_fha_6_1.json
// module id = 207
// module chunks = 0